const defaultArray = [];

export const getMessages = ({ messaging: { messages = defaultArray } }) => messages;

export const getUnreadMessagesNumber = ({ messaging: { messages = defaultArray } }) =>
  messages.filter(({ read }) => !read).length;
